// 현금영수증 관리 섹션 URL (2026-08-06 KST 추가)
const cashReceiptsSection = "/cash-receipts";

export const cashReceiptsPath = cashReceiptsSection;
